import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './agenda-item.types';
import * as constants from './agenda-item.constants';

export const storeAgendaItem = generateStoreResourceAction<types.IAgenda>(constants.STORE_AGENDA_ITEM);
export const clearAgendaItem = generateClearResourceAction(constants.CLEAR_AGENDA_ITEM);
